var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBytedance = function SvgBytedance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    viewBox: "1.37 0 1198.25 1051.64",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M206.82 943.8 1.37 996.54V55.1l205.45 53.14z",
    fill: "#325ab4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m532.79 972.14-205.44 53.13V470.72l205.44 53.13z",
    fill: "#3c8cff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m667.02 388.86 205.84-53.14v554.55l-205.84-53.13z",
    fill: "#00c8d2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m1199.62 998.9-205.84 52.74V0l205.84 53.13z",
    fill: "#78e6dc"
  })));
};
export default SvgBytedance;